<template>
  <div class="h-full flex flex-col">
    <!-- 欢迎界面 -->
    <div class="flex-1 flex flex-col items-center justify-center p-8">
      <div class="max-w-2xl w-full space-y-8">
        <!-- Logo和标题 -->
        <div class="text-center">
          <div class="text-6xl mb-4">🤖</div>
          <h1 class="text-4xl font-bold mb-2">欢迎使用 AI Chat</h1>
          <p class="text-gray-600 dark:text-gray-400">
            智能对话助手，为您提供专业的解答
          </p>
        </div>

        <!-- 快速开始卡片 -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
            <h3 class="text-lg font-semibold mb-2">开始新对话</h3>
            <p class="text-gray-600 dark:text-gray-400 mb-4">
              点击左侧"新建聊天"按钮，开始一段新的对话。
            </p>
            <button @click="startNewChat()" class="text-blue-500 hover:text-blue-600 font-medium">
              立即开始 →
            </button>
          </div>

          <div class="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
            <h3 class="text-lg font-semibold mb-2">查看历史对话</h3>
            <p class="text-gray-600 dark:text-gray-400 mb-4">
              在左侧边栏查看您的历史对话记录。
            </p>
            <button class="text-blue-500 hover:text-blue-600 font-medium">
              浏览历史 →
            </button>
          </div>
        </div>

        <!-- 示例问题 -->
        <div class="space-y-4">
          <h2 class="text-lg font-semibold">你可以这样问我：</h2>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <button 
              v-for="(question, index) in exampleQuestions" 
              :key="index"
              @click="startChatWithQuestion(question)"
              class="text-left p-3 rounded-lg bg-gray-50 dark:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              "{{ question }}"
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部输入框 -->
    <div class="p-4 border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
      <div class="max-w-3xl mx-auto">
        <div class="relative">
          <input
            v-model="inputQuestion"
            type="text"
            placeholder="输入你的问题..."
            class="w-full px-4 py-3 pr-12 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @keyup.enter="handleQuestionSubmit"
          >
          <button 
            @click="handleQuestionSubmit"
            class="absolute right-3 top-1/2 -translate-y-1/2 text-blue-500 hover:text-blue-600"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      exampleQuestions: [
        "你能帮我解释一下量子计算吗？",
        "如何提高编程效率？",
        "帮我写一首诗歌",
        "如何学习一门新语言？"
      ],
      inputQuestion: ''
    }
  },
  methods: {
    startNewChat() {
      this.$router.push('/chat')
    },
    startChatWithQuestion(question) {
      localStorage.setItem('pendingQuestion', question)
      this.inputQuestion = ''
      this.$router.push('/chat')
    },
    handleQuestionSubmit() {
      if (this.inputQuestion.trim()) {
        this.startChatWithQuestion(this.inputQuestion.trim())
      }
    }
  }
}
</script> 